export const loginMessages = {
    loginSuccess: "Inicio de sesión exitoso",
    NotAuthorizedException: "¡Usario o contraseña incorrectos!",
    UserNotFoundException: "¡Usario o contraseña incorrectos!",
  };
  